(() => {
  const ROOT_SELECTOR = '[data-vzy-benefits-card]';

  const initBenefitsCard = (root) => {
    if (!root || root.dataset.vzyBenefitsReady === 'true') return;

    const host = root.closest('.custom-liquid');
    const destination = root.querySelector('[data-vzy-existing-benefits]');
    if (!host || !destination) return;

    const benefitBlocks = [];
    let sibling = host.nextElementSibling;
    while (sibling && benefitBlocks.length < 3) {
      if (!sibling.classList.contains('product__text-icons')) break;
      benefitBlocks.push(sibling);
      sibling = sibling.nextElementSibling;
    }

    if (!benefitBlocks.length) {
      root.dataset.vzyBenefitsStatus = 'source-not-found';
      return;
    }

    benefitBlocks.forEach((block) => destination.append(block));
    host.classList.add('vzy-benefits-card-v2__host');
    root.dataset.vzyBenefitsReady = 'true';
    root.dataset.vzyBenefitsStatus = benefitBlocks.length === 3 ? 'ready' : 'partial';
  };

  const initAll = (scope = document) => {
    if (scope.matches?.(ROOT_SELECTOR)) initBenefitsCard(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initBenefitsCard);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

